import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import { AppState } from "../../../store/app_state";

import styled from "styled-components";
import {
  ConstBorderRound,
  ConstColor,
} from "../../../../config/styles_const/styles_const";
import * as Validator from "../../../../util/validation";
import BtnBorderLarge from "../../../common/atom/btn/btn_border_large";
import FormInput from "../../../common/atom/form/form_input";
import ErrorText from "../../../common/atom/text/error_text";

interface IStateProps {
  initialValues: {
    placeholder: string;
  };
}

interface IProps extends IStateProps {}

interface IState {}

const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

const renderInputCustom = (field: any) => {
  const hasError = !!field.meta.error && !!field.meta.touched;

  return (
    <React.Fragment>
      <CustomInput
        {...field.input}
        type={field.type}
        placeholder={field.placeholder}
      />
      {hasError && (
        <div>
          <ErrorText>{field.meta.error}</ErrorText>
        </div>
      )}
    </React.Fragment>
  );
};

export class LayoutSearchFormForMenu extends React.Component<
  IProps & InjectedFormProps<{}, IProps>,
  IState
> {
  constructor(props: IProps & InjectedFormProps<{}, IProps>) {
    super(props);

    this.state = {};
  }

  public render(): JSX.Element {
    const { handleSubmit, initialValues } = this.props;

    return (
      <SearchWrapper>
        <form onSubmit={handleSubmit}>
          <SearchInputWrapper>
            <Field
              placeholder={initialValues.placeholder}
              name="q"
              component={renderInputCustom}
              type="text"
              validate={[Validator.query]}
            />
            <IconButton aria-label="Search" type="submit" icon={"'\f002'"} />
          </SearchInputWrapper>
        </form>
      </SearchWrapper>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm({
  // form: "ClientScoutCustomerListSearchForm",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(LayoutSearchFormForMenu));

const CustomInput = styled(FormInput)`
  padding-right: 0;
  height: 50px;
  background: white;
  border-radius: ${ConstBorderRound.CornerRoundLeftTopLeftBottom};
  border: none;
  color: ${ConstColor.DeepBlack};
  &:focus {
    outline: 0;
    border: none;
  }
  // chrome のautofill時のcss打ち消し用
  input&:-webkit-autofill,
  input&:-webkit-autofill:hover,
  input&:-webkit-autofill:focus {
    border: none;
    color: ${ConstColor.White};
    caret-color: ${ConstColor.White};
    -webkit-text-fill-color: ${ConstColor.White};
    -webkit-box-shadow: 0 0 0px 1000px ${ConstColor.Base} inset;
    transition: background-color 5000s ease-in-out 0s;
  }
  &::placeholder {
    font-size: 12px;
  }
`;

const SearchWrapper = styled.div`
  margin-left: 15px;
  margin-right: 15px;
`;

const SearchInputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: ${ConstBorderRound.CornerRoundAll};
  border: 1px solid ${ConstColor.Base};
`;

const IconButton = styled(BtnBorderLarge)`
  width: 50px;
  border-radius: ${ConstBorderRound.CornerRoundRightTopRightBottom};
  border: none;
  background: white;
  color: ${ConstColor.Gray};
`;



// WEBPACK FOOTER //
// ./src/presentation/component/layout/share/layout_search_form.tsx